module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_main_contents"
  }, [_vm._m(0), _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_c('div', {
    staticClass: "settinglinkarea"
  }, [_c('router-link', {
    staticClass: "settinglink",
    attrs: {
      "to": "adminsettings/accounts"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('h3', [_vm._v("アカウント設定")]), _c('p', [_vm._v("管理者のみが設定できます。"), _c('br'), _vm._v("こちらから全てのユーザの設定が可能です。")])])], 1), _c('div', {
    staticClass: "settinglinkarea"
  }, [_c('router-link', {
    staticClass: "settinglink",
    attrs: {
      "to": "adminsettings/agreement"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _c('h3', [_vm._v("登録・契約情報")]), _c('p', [_vm._v("管理者のみが閲覧できます。"), _c('br'), _vm._v("こちらから契約内容を確認できます。また、一部の内容変更が可能です。")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "title_left"
  }, [_c('h2', [_vm._v("各種設定")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0faff43d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/admin/Index.vue
// module id = 592
// module chunks = 1